import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';
import { saveActivityTimerSession } from 'hooks/useOfflineActivityTimer';

type ActivityTimeStartData = {
  orderUuid: any;
  activityUuid: string;
  comment?: string;
  activityName?: string;
};

const usePostActivityTimeStart = (
  options?: UseMutationOptions<any, Error, ActivityTimeStartData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['startActivityTime'],
    mutationFn: async (data: ActivityTimeStartData) => {
      const response = await axiosInstance.post(`/activity/time-start`, data).then((res) => res.data);

      try {
        const timeManagement = (response as any)?.timeManagement;
        if (timeManagement) {
          saveActivityTimerSession({
            orderUuid: data.orderUuid,
            activityUuid: data.activityUuid,
            timeManagementUuid: timeManagement.uuid,
            dateStart: timeManagement.dateStart,
            activityName: timeManagement.activityName ?? null,
            comment: data.comment ?? null,
            startedOnline: true,
          });

          // Po udanym starcie czasu online poinformuj service workera,
          // aby mógł zaktualizować cache time-management.
          try {
            if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
              console.log('czy to wogole tu weszło?')
              navigator.serviceWorker.controller.postMessage({
                type: 'UPDATE_ACTIVITY_TIME_MANAGEMENT',
                orderUuid: data.orderUuid,
                activityUuid: data.activityUuid,
                activityName: timeManagement.activityName ?? data.activityName,
                timeManagement,
              });
            }
          } catch (swError) {
            console.error(
              '❌ Error sending UPDATE_ACTIVITY_TIME_MANAGEMENT message to SW after time-start:',
              swError
            );
          }
        }
      } catch (error) {
        console.error('❌ Error saving activity timer session after time-start:', error);
      }

      return response;
    },
    onMutate: (variables) => {
      Toast({
        message: 'Rozpoczynanie liczenia czasu dla aktywności...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'start-activity-time',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Czas dla aktywności rozpoczęty pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'start-activity-time',
      });
      queryClient.invalidateQueries({ queryKey: ['timeManagement'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas rozpoczynania mierzenia czasu dla aktywności.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'start-activity-time',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePostActivityTimeStart;
